/* FBK 14-10-2026 homepage compact: "Lees meer" voor de SEO-tekst en "Meer vragen" voor de FAQ.
   Alle tekst blijft in de HTML; dit script verandert alleen de weergave. Labels per taal (html lang). */
(function () {
  var L = {
    nl: ['Lees meer', 'Lees minder', 'Meer vragen', 'Minder vragen'],
    en: ['Read more', 'Read less', 'More questions', 'Fewer questions'],
    de: ['Mehr lesen', 'Weniger lesen', 'Mehr Fragen', 'Weniger Fragen'],
    fr: ['Lire plus', 'Lire moins', 'Plus de questions', 'Moins de questions'],
    es: ['Leer más', 'Leer menos', 'Más preguntas', 'Menos preguntas'],
    it: ['Leggi di più', 'Leggi meno', 'Altre domande', 'Meno domande'],
    pl: ['Czytaj więcej', 'Czytaj mniej', 'Więcej pytań', 'Mniej pytań'],
    tr: ['Devamını oku', 'Daha az göster', 'Daha fazla soru', 'Daha az soru'],
    ru: ['Читать далее', 'Свернуть', 'Больше вопросов', 'Меньше вопросов'],
    uk: ['Читати далі', 'Згорнути', 'Більше запитань', 'Менше запитань'],
    ar: ['اقرأ المزيد', 'اقرأ أقل', 'المزيد من الأسئلة', 'أسئلة أقل']
  };
  var lang = (document.documentElement.lang || 'nl').slice(0, 2).toLowerCase();
  var T = L[lang] || L.nl;
  var ICON = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M6 9l6 6 6-6"></path></svg>';

  function makeBtn(more, less, onToggle) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'fbk-more-btn';
    b.setAttribute('aria-expanded', 'false');
    var span = document.createElement('span');
    span.textContent = more;
    b.appendChild(span);
    b.insertAdjacentHTML('beforeend', ICON);
    b.addEventListener('click', function () {
      var open = b.getAttribute('aria-expanded') !== 'true';
      b.setAttribute('aria-expanded', open ? 'true' : 'false');
      span.textContent = open ? less : more;
      onToggle(open);
      if (!open) { b.scrollIntoView({ block: 'center' }); }
    });
    return b;
  }

  function init() {
    // 1. SEO-tekst: inklappen als hij duidelijk hoger is dan 760px
    var rt = document.querySelector('.shopify-section[id$="__rich_text_UYDR3k"] .rich-text');
    if (rt && rt.scrollHeight > 760 + 160) {
      rt.classList.add('fbk-collapsible');
      var btn = makeBtn(T[0], T[1], function (open) { rt.classList.toggle('is-expanded', open); });
      rt.insertAdjacentElement('afterend', btn);
    }
    // 2. FAQ: eerste 7 vragen, rest achter een knop
    var list = document.querySelector('.shopify-section[id$="__custom_liquid_Qhxt3P"] .fb-faq-list');
    if (list) {
      var items = list.querySelectorAll(':scope > .fb-faq-item');
      if (items.length > 7) {
        list.classList.add('fbk-faq-limited');
        var fb = makeBtn(T[2] + ' (' + (items.length - 7) + ')', T[3], function (open) { list.classList.toggle('is-expanded', open); });
        list.insertAdjacentElement('afterend', fb);
      }
    }
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
})();
